import { Component, Input, ViewChild } from '@angular/core';
import { User } from '../../services/user.model';

import {
    faAngleDown,
    faCameraPolaroid,
    faFileCheck,
    faLongArrowUp,
} from '@fortawesome/pro-regular-svg-icons';
import { TicketService } from 'src/app/services/ticket.service';
import { AuthService } from 'src/app/services/auth.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-new-ticket',
  templateUrl: './new-ticket.component.html',
  styleUrls: ['./new-ticket.component.scss'],
})
export class NewTicketComponent {
    @Input() user: User;
    @ViewChild('fileInput') fileInput;

    name: string;
    category: string = 'Sonstiges';
    description: string = '';
    address: string = '';
    files: FileList;
    uploadPercent: Observable<number>;
    downloadURLs: any[];

    categorys: any[] = [
        'Rollladen',
        'Jalousien',
        'Markisen',
        'Fliegengitter',
        'Sonstiges',
    ];

    constructor(public auth: AuthService,public ticketService: TicketService) {
        // get ticket name
        const date = new Date();
        ticketService.tickets$.subscribe(data => {
            let number = data.length + 1;
            this.name = 'T' + date.getDate() + (date.getMonth() + 1) + date.getFullYear() + '-' + number;
        });
        // get address
        auth.user$?.subscribe((user) => {
            if(user.zipcity && user.streetnumber) {
                this.address = user.zipcity + ', ' + user.streetnumber
            }
        })
    }

  async addTicket() {
    let createdAt: any = new Date;
    createdAt = createdAt.getTime();
    this.auth.user$?.subscribe((user) => {
      const data = {
        createdAt: createdAt,
        uid: user.uid,
        creator: user.name,
        mail: user.mail,
        phone: user.phone,
        name: this.name,
        category: this.category,
        description: this.description,
        address: this.address,
      };
      // add Ticket
      this.ticketService.addTicket(data, this.files);
      console.log(this.address);
      // clear Data
      this.description = '';
      this.address = '';
      this.category = 'Sonstiges';
      this.fileInput.nativeElement.value = null;
    });
  }

  handleFileInput(files) {
    if (files.length > 2) {
      alert('Sie können maximal 2 Bilder hochladen.');
    } else {
      this.files = files;
    }
  }

  angleDown = faAngleDown;
  cameraPolaroid = faCameraPolaroid;
  fileCheck = faFileCheck;
  longArrowUp = faLongArrowUp;
}
